import { googleMapAPIKey } from '../settings';

let loadPromise = null;

export function loadGoogleMapsScript(libraries = 'places') {
  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  if (!googleMapAPIKey) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY is not configured'));
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapAPIKey}&libraries=${libraries}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Maps JavaScript API'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
